import { axios } from '@/utils/request'
const prefix = 'https://service-dbdzfsuf-1301483065.sh.apigw.tencentcs.com:443/api'
const api = {
    getTaobaoOrderList: '/5ff7b79eb13e7',
    getJingdongOrderList: '/5ff7bc80027d5',

    getCsjOrderList: '/6620e78327cf7', // 穿山甲

    getPinduoduoOrderList: '/5ff7b9902fe94',
    getWeipinhuiOrderList: '/6066b9ce306d0',
    getDouyinOrderList: '/61ce585b77e1b',
    updateOrderReplaceUid: '/5cbebc6e0398f',
    addBlackList: '/62fc8f333b120',
    getBlackList: '/62fc9ff917eb6',
    deleteBlackUser: '/62fca51d60b0a',
    getDYDistributionOrder: '/630d6b0f1000b',
    getMgMovieOrderList: '/633696e6eee3a',
    getHxwlOrderList: '/638feb9aaf0c8', // 欢喜物流订单列表
    getKdyInfo: '/6391418f2d13a', // 欢喜物流-订单列表-查看快递员信息
    getDingDanInfo: '/63928f7237a5d', // 欢喜物流-点击订单号-展示的信息
}

export default {
    // 加入黑名单
    addBlackList: ({ sub_id, store_name, source, type, remark, seller_nick }) => {
        const parameter = {
            sub_id,
            store_name,
            source,
            type,
            remark,
            seller_nick
        }
        return axios({
            url: api.addBlackList,
            method: 'post',
            data: parameter,
        })
    },
    // 获取店铺黑名单列表
    getBlackList: parameter => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20,
        })
        return axios({
            url: api.getBlackList,
            method: 'get',
            params: params,
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count,
            }
        })
    },
    // 移除店铺黑名单用户
    deleteBlackUser: ({ ids }) => {
        const parameter = { white_list: ids }
        return axios({
            url: api.deleteBlackUser,
            method: 'post',
            data: parameter,
        })
    },
    // 欢喜物流订单列表
    getHxwlOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getTaobaoOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 获取淘宝订单列表
    getTaobaoOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getTaobaoOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 获取京东订单列表
    getJingdongOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getJingdongOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },

    // 获取穿山甲订单列表
    getCsjOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getCsjOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },

    // 获取拼多多订单列表
    getPinduoduoOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getPinduoduoOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 获取唯品会订单列表
    getWeipinhuiOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getWeipinhuiOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 获取抖Y订单列表
    getDouyinOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getDouyinOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    //获取抖音分销订单
    getDYDistributionOrder: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getDYDistributionOrder,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 订单换绑
    updateOrderReplaceUid: ({ robotid, orderid, uid }) => {
        const params = {
            sub_id: robotid,
            order_id: orderid,
            uid: uid
        }
        return axios({
            url: api.updateOrderReplaceUid,
            method: 'post',
            data: params
        })
    },
    // 获取唯品会订单列表
    getMgMovieOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getMgMovieOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 获取欢喜物流订单列表
    getHxwlOrderList: (parameter) => {
        const params = Object.assign(parameter, {
            page: parameter.pageNo || 1,
            size: parameter.pageSize || 20
        })
        return axios({
            url: api.getHxwlOrderList,
            method: 'get',
            params: params
        }).then(res => {
            return {
                data: res.data.list || [],
                pageNo: parameter.pageNo,
                pageSize: parameter.pageSize,
                totalCount: res.data.count
            }
        })
    },
    // 欢喜物流-订单列表-查看快递员信息
    getKdyInfo: (parameter) => {
        return axios({
            url: api.getKdyInfo,
            method: 'post',
            data: parameter
        })
    },
    // // 欢喜物流-点击订单号-展示的信息
    getDingDanInfo: (parameter) => {
        return axios({
            url: api.getDingDanInfo,
            method: 'get',
            params: parameter
        })
    },
}
